import ContractsValidCollection, {
  ContractsValidCollectionTaxiContractTaxiCorporation,
} from "../../../../../common/services/contracts/valid-collection/contracts-valid-collection";
import OrderDetailsChangeTaxiTaxiCorporationSelectOption from "./types/order-details-change-taxi-taxi-corporation-select-option";

const createTaxiCorporationSelectOption = (
  responseTaxiCorporation: ContractsValidCollectionTaxiContractTaxiCorporation,
): OrderDetailsChangeTaxiTaxiCorporationSelectOption => {
  return {
    label: responseTaxiCorporation.displayName,
    value: {
      uuid: responseTaxiCorporation.id,
      name: responseTaxiCorporation.displayName,
    },
  };
};

const createTaxiCorporationsSelectOptions = (
  taxiContractsResponseData: ContractsValidCollection,
): OrderDetailsChangeTaxiTaxiCorporationSelectOption[] => {
  return taxiContractsResponseData.taxiContracts.map((taxiContract) =>
    createTaxiCorporationSelectOption(taxiContract.taxiCorporation),
  );
};

const orderDetailsChangeTaxiFactory = {
  createTaxiCorporationsSelectOptions,
};

export default orderDetailsChangeTaxiFactory;
